/* eslint-disable radix */
import React, { useMemo } from 'react';

import { Box, Flex } from '@chakra-ui/react';
import styled from '@emotion/styled';
import { getMonth, getYear, setMonth, setYear } from 'date-fns';
import { range } from 'es-toolkit/compat';

import { ArrowLeft, ArrowRight } from 'assets/assetsV1/iconComponents';

import { Button } from 'uiToolkitV1/Button';
import { SelectDashed } from 'uiToolkitV1/Select';

const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];
const monthOptions = months.map((month, index) => ({ value: index, label: month }));

const Header = ({ date, setDate, nextDisabled, prevDisabled, onClickNext, onClickPrevious, minDate, maxDate }) => {
  const handleMonthChange = ({ value }) => {
    setDate(setMonth(date, parseInt(value)));
  };

  const handleYearChange = ({ value }) => {
    setDate(setYear(date, parseInt(value)));
  };

  const yearOptions = useMemo(() => {
    const startYear = minDate ? getYear(minDate) : getYear(new Date()) - 10;
    const endYear = maxDate ? getYear(maxDate) : getYear(new Date()) + 10;
    const years = range(startYear, endYear + 1, 1);
    const yearOptions = years.map((year) => ({ value: year, label: year }));
    return yearOptions;
  }, [maxDate?.toString(), minDate?.toString()]);

  return (
    <Flex container justifyContent="space-between" alignItems="center" width="100%">
      <Box>
        <ArrowButton StartIcon={ArrowLeft} variant="tertiary" disabled={prevDisabled} onClick={onClickPrevious} />
      </Box>
      <Flex gap={4} flexGrow={1} justifyContent="center">
        <Box>
          <SelectDashed
            value={monthOptions.filter(({ value }) => value === getMonth(date))[0]}
            handleChange={handleMonthChange}
            options={monthOptions}
            isSearchable={false}
            minWidth="min-content"
            boldText
          />
        </Box>
        <Box>
          <SelectDashed
            value={yearOptions.filter(({ value }) => value === getYear(date))[0]}
            handleChange={handleYearChange}
            options={yearOptions}
            isSearchable={false}
            minWidth="min-content"
            boldText
          />
        </Box>
      </Flex>

      {/* <Grid item>

        <TextBodyMedium bold>{format(date, 'MMM yyyy')}</TextBodyMedium>
      </Grid> */}
      <Box>
        <ArrowButton variant="tertiary" StartIcon={ArrowRight} disabled={nextDisabled} onClick={onClickNext} />
      </Box>
    </Flex>
  );
};

const ArrowButton = styled(Button)`
  margin-left: 6px;
  svg {
    color: ${(props) => props.theme.colors.text.g1} !important;
  }
  visibility: ${(props) => (props.disabled ? 'hidden' : 'visible')};
`;

export default Header;
